/**
 * Utility functions to create and load wheelchair icons for map layers
 */

import wheelchairSvg from './wheelchair-designated.svg?raw';
import wheelchairNoSvg from './wheelchair-no.svg?raw';

export function loadWheelchairIcons(map: any) {
    // Load wheelchair designated icon - MUTCD D9-6
    if (!map.hasImage('wheelchair-designated')) {
        const wheelchairImg = new Image();
        wheelchairImg.onload = () => map.addImage('wheelchair-designated', wheelchairImg);
        wheelchairImg.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(wheelchairSvg);
    }

    // Load wheelchair no icon - MUTCD D9-6 with red prohibition
    if (!map.hasImage('wheelchair-no')) {
        const wheelchairNoImg = new Image();
        wheelchairNoImg.onload = () => map.addImage('wheelchair-no', wheelchairNoImg);
        wheelchairNoImg.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(wheelchairNoSvg);
    }
}

